
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/contact",
      function () {
        return require("private-next-pages/landing/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/contact"])
      });
    }
  